

















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class BigLoading extends Vue {
  private showLinkToApplication = false;

  created() {
    setTimeout(() => {
      this.showLinkToApplication = true;
    }, 5000);
  }
}
